import ReactController from '~/controllers/react_controller'
import AzureVirtualMachinesDashboardCharts from '~/dashboard/azure_virtual_machines_dashboard_charts'

export default class AzureVirtualMachinesDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    return <AzureVirtualMachinesDashboardCharts organizationId={this.organizationIdValue} />
  }
}
